export class Cliente {
    [key: string]: string | number | undefined
    public id: number | undefined;
    public razonSocial: string | undefined;
    public cif: string | undefined;
    public direccion: string | undefined;
    public codigoPostal: string | undefined;
    public localidad: string | undefined;
    public provincia: string | undefined;
    public pais: string | undefined;
    public verticalId: number | undefined;
    public defaultFallow: number | undefined = 0;
}
